import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *随堂练习列表
 * @param params
 * 
*/

export const quizList = params => Http.get(`${baseUrl}/activity/quiz`, { params })

/**
 *批改题目分数
 * @param params
 * 
*/

export const quizScore = params => Http.put(`${baseUrl}/activity/quiz/score`,  params )
